<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
div(class="border-bottom")
    ib-row(class="show-filter")
        ib-col(class="xl3 new-products")
            p(
                class="insety-8", 
                :class="{'insetx-4': !$media.m, 'insetx-8': $media.l, 'insetx-16': $media.xl}"
            ) 
                span(
                    class="info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('select_new_products') }}
                span {{ $t('show_products') }}
        ib-col(class="xl9 insety-8", :class="{ 'show-products': $media.xl, 'sp':!$media.xl }")
            ib-radio(name="product", v-model="value", val="all", tone="error", :class="{'text-bold': value === 'all'}") {{ $t('all') }}
            ib-radio(name="product", v-model="value", val="new", tone="error", :class="{'text-bold': value === 'new'}") {{ $t('new_products_only') }} ( &#8804; {{ $t('30_days') }} )
            ib-radio(name="product", v-model="value", val="existing", tone="error", :class="{'text-bold': value === 'existing'}") {{ $t('existing_products_only') }} ( > {{ $t('30_days') }} )
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: 'NewProduct',
    components: {

    },
    data () {
        return {
            value: 'all',
        }
    },
    watch: {
        value(newValue, oldValue){
            this.setNewProducts(newValue);
        }
    },
    methods: {
        reset() {
            this.value = 'all';
        },
        ...mapActions(['setNewProducts'])
    },
}
</script>

<style>
.center-radio{
    display: inline;
    &:after {
        background-color: #000;
    }
}
.new-products{
    display: block;
}
.show-products{
    display: flex;
    flex-direction: row;
    padding-top: 4px;
}
.sp {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-left: 8px;    
}
.pl-8 {
    padding-left: 8px;
}
</style>